import React, { useState } from 'react'
import hipersendService from '../../services/hipersend'
import CountryCodesModal from '../CountryCodesModal'
import { BRASIL, CampoDeNumero, exibidoDe, mensagemDoErro, numeroCompleto, resultadoDoEnvio, telefoneDe } from './envioDeTeste'

// "Teste antes no seu número": UMA mensagem de verdade, com os dados do
// primeiro da lista, para o número que a pessoa digitar. Pede confirmação
// antes de enviar — sai pelo mesmo caminho de qualquer envio da conexão.

export default function TesteNoSeuNumero({ api, secret, mensagem, arquivo = '', oficial, desabilitado }) {
  const [pais, setPais] = useState(BRASIL)
  const [escolhendoPais, setEscolhendoPais] = useState(false)
  const [numeroDigitado, setNumeroDigitado] = useState('')
  const [etapa, setEtapa] = useState('editar')
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')

  const exibido = exibidoDe(pais, numeroDigitado)

  const enviar = async () => {
    setEtapa('enviando')
    setErro('')
    setAviso('')
    try {
      const resposta = await hipersendService.notificacoesInteligentes.sendMessage(api, secret, {
        message: mensagem,
        phone: telefoneDe(pais, numeroDigitado),
        // Na API Oficial o modelo vai sem anexo, como no "Testar envio" dos modelos.
        fileUrl: oficial ? '' : arquivo.trim()
      })
      const r = resultadoDoEnvio(resposta)
      if (r.estado === 'retida') setAviso(r.texto)
      setEtapa(r.estado === 'ok' ? 'ok' : 'editar')
    } catch (e) {
      setErro(mensagemDoErro(e))
      setEtapa('editar')
    }
  }

  return (
    <div className="dp-bloco">
      <CountryCodesModal
        open={escolhendoPais}
        onClose={() => setEscolhendoPais(false)}
        onSelect={(p) => { setEscolhendoPais(false); setPais(p) }}
      />
      <h4>Teste antes no seu número</h4>
      <p className="dp-sub">
        Envia uma mensagem de verdade só para você, com os dados do primeiro da lista.
        {oficial ? ' Conta como uma mensagem no seu saldo.' : ''}
      </p>

      {etapa === 'confirmar' || etapa === 'enviando' ? (
        <div className="dp-confirma-teste">
          <span>Enviar 1 mensagem de teste para <b>{exibido}</b>?</span>
          <div className="dp-linha-botoes">
            <button type="button" className="dp-btn" onClick={() => setEtapa('editar')} disabled={etapa === 'enviando'}>
              Voltar
            </button>
            <button type="button" className="dp-btn pri" onClick={enviar} disabled={etapa === 'enviando'}>
              {etapa === 'enviando' ? 'Enviando…' : 'Enviar teste agora'}
            </button>
          </div>
        </div>
      ) : (
        <div className="dp-teste">
          <CampoDeNumero
            pais={pais}
            onEscolherPais={() => setEscolhendoPais(true)}
            rotulo="Seu número com DDD"
            valor={numeroDigitado}
            onValor={(v) => { setNumeroDigitado(v); if (etapa === 'ok') setEtapa('editar') }}
          />
          <button
            type="button"
            className="dp-btn"
            disabled={desabilitado || !numeroCompleto(numeroDigitado) || !mensagem}
            onClick={() => setEtapa('confirmar')}
          >
            Enviar teste
          </button>
        </div>
      )}

      {etapa === 'ok' && <p className="dp-ok" style={{ marginTop: 8 }}>Teste enviado para {exibido}. Confira no WhatsApp.</p>}
      {aviso && <p className="dp-aviso" role="status" style={{ marginTop: 8 }}>{aviso}</p>}
      {erro && <p className="dp-erro" style={{ marginTop: 8 }}>{erro}</p>}
    </div>
  )
}
